<div class="wrapper__white-bg">
  <img
    class="error-image"
    src="./assets/images/error.svg"
    title="Algo deu errado"
    alt="[Imagem] Algo deu errado"
  />

  <p class="title">Algo deu errado</p>

  <p class="error-message">
    Estamos trabalhando para resolver esse problema. <br />Por favor, tente
    novamente mais tarde e, se o erro persistir, entre em contato com a nossa
    equipe de atendimento.
  </p>
</div>
